function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["style", "optionTextAutoBreak", "arrowRotate", "tabIndex", "customButton", "contentCenter", "allowClear", "notFoundText", "defaultValue", "onChange", "options", "showSearch", "mode", "placeholder", "size", "tagSize", "RenderNode", "valueRender", "value", "autoWidth", "width", "height", "className", "placement", "direction", "dropDownWidth", "getPopupContainer", "onDropdownVisibleChange", "optionClass", "dropdownClassName", "shadowRootDelayTime", "virtual", "hoverAction", "hoverTime", "dropdownOpen", "dropDownHeader", "dropDownFooter", "unEnabledDefaultVisible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { cn } from "../../../lib/utils";
import { ArrowdownIcon, CheckIcon, EmptyIcon } from '@bfe/moly-icons';
import RcSelect, { Option } from 'rc-select';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Divider from "../divider";
import Empty from "../empty";
import { Search } from "../search";
import { Tag } from "../tag";
import { useSelectHover } from "./hooks/useSelectHover";
import { dropDownStyles, optionStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultOptionLabel = function defaultOptionLabel(val, optionTextAutoBreak) {
  return /*#__PURE__*/_jsx("div", {
    className: cn(optionTextAutoBreak ? 'whitespace-break-spaces' : 'truncate'),
    title: val,
    children: val
  });
};
var fontSizeVariable = {
  xs: ['text-[12px] font-medium leading-[18px]'],
  small: ['text-[12px] font-medium leading-[18px]'],
  medium: ['text-[16px] font-medium leading-6'],
  large: ['text-[20px] font-medium leading-7']
};
var containerVariable = {
  xs: ['min-h-[32px] h-auto px-[8px]  py-[7px]  rounded-[4px]'],
  small: ['min-h-[40px] h-auto px-[12px]  rounded-[4px]'],
  medium: ['min-h-[48px] h-auto px-[16px]  rounded-[8px]']
};
var Select = function Select(_props) {
  var _props$style = _props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$optionTextAuto = _props.optionTextAutoBreak,
    optionTextAutoBreak = _props$optionTextAuto === void 0 ? false : _props$optionTextAuto,
    _props$arrowRotate = _props.arrowRotate,
    arrowRotate = _props$arrowRotate === void 0 ? true : _props$arrowRotate,
    _props$tabIndex = _props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 1 : _props$tabIndex,
    customButton = _props.customButton,
    contentCenter = _props.contentCenter,
    allowClear = _props.allowClear,
    notFoundText = _props.notFoundText,
    defaultValue = _props.defaultValue,
    _onChange = _props.onChange,
    _props$options = _props.options,
    options = _props$options === void 0 ? [] : _props$options,
    showSearch = _props.showSearch,
    _props$mode = _props.mode,
    mode = _props$mode === void 0 ? 'combobox' : _props$mode,
    _props$placeholder = _props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'please select' : _props$placeholder,
    _props$size = _props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    tagSize = _props.tagSize,
    RenderNode = _props.RenderNode,
    valueRender = _props.valueRender,
    value = _props.value,
    autoWidth = _props.autoWidth,
    width = _props.width,
    height = _props.height,
    className = _props.className,
    _props$placement = _props.placement,
    placement = _props$placement === void 0 ? undefined : _props$placement,
    _props$direction = _props.direction,
    direction = _props$direction === void 0 ? 'ltr' : _props$direction,
    dropDownWidth = _props.dropDownWidth,
    _getPopupContainer = _props.getPopupContainer,
    onDropdownVisibleChange = _props.onDropdownVisibleChange,
    optionClass = _props.optionClass,
    dropdownClassName = _props.dropdownClassName,
    shadowRootDelayTime = _props.shadowRootDelayTime,
    _props$virtual = _props.virtual,
    virtual = _props$virtual === void 0 ? true : _props$virtual,
    hoverAction = _props.hoverAction,
    _props$hoverTime = _props.hoverTime,
    hoverTime = _props$hoverTime === void 0 ? 300 : _props$hoverTime,
    dropdownOpen = _props.dropdownOpen,
    _props$dropDownHeader = _props.dropDownHeader,
    dropDownHeader = _props$dropDownHeader === void 0 ? null : _props$dropDownHeader,
    _props$dropDownFooter = _props.dropDownFooter,
    dropDownFooter = _props$dropDownFooter === void 0 ? null : _props$dropDownFooter,
    unEnabledDefaultVisible = _props.unEnabledDefaultVisible,
    rest = _objectWithoutProperties(_props, _excluded);
  if (!width && !autoWidth) {
    if (size === 'medium') {
      width = 380;
    } else {
      width = 276;
    }
  }
  if (!height) {
    if (size === 'medium') {
      height = 48;
    } else if (size === 'xs') {
      height = 32;
    } else {
      height = 40;
    }
  }
  var dropRef = useRef(null);
  var _useState = useState('label_' + (Math.random() * 100000000).toFixed(0)),
    _useState2 = _slicedToArray(_useState, 2),
    labelId = _useState2[0],
    setLabelId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dropdownVisible = _useState4[0],
    setDropdownVisible = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filterValue = _useState6[0],
    setFilterValue = _useState6[1];
  var _useState7 = useState(['tags', 'multiple'].includes(mode) && !Array.isArray(value) ? [] : value),
    _useState8 = _slicedToArray(_useState7, 2),
    selectValue = _useState8[0],
    setSelectValue = _useState8[1];
  var _useState9 = useState('rc_' + (Math.random() * 100000000).toFixed(0)),
    _useState10 = _slicedToArray(_useState9, 2),
    rcId = _useState10[0],
    setRcId = _useState10[1];
  var _useState11 = useState(document.body),
    _useState12 = _slicedToArray(_useState11, 2),
    popUpContainer = _useState12[0],
    setPopUpContainer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dropDownHover = _useState14[0],
    setDropDownHover = _useState14[1];
  useEffect(function () {
    if (dropdownOpen !== undefined) {
      setDropdownVisible(dropdownOpen);
    }
  }, [dropdownOpen]);
  var _useSelectHover = useSelectHover({
      hoverAction: hoverAction,
      hoverTime: hoverTime,
      setDropdownVisible: setDropdownVisible,
      onDropdownVisibleChange: onDropdownVisibleChange
    }),
    mouseEnterHandler = _useSelectHover.mouseEnterHandler,
    mouseLeaveHandler = _useSelectHover.mouseLeaveHandler,
    dropdownMouseEnterHandler = _useSelectHover.dropdownMouseEnterHandler,
    dropdownMouseLeaveHandler = _useSelectHover.dropdownMouseLeaveHandler;
  var computedSelectValueContainer = function computedSelectValueContainer() {
    var width = 'calc(100% - 14px)';
    if (size === 'medium' || !size) {
      width = 'calc(100% - 16px)';
    }
    return {
      width: width
    };
  };
  useLayoutEffect(function () {
    var _element3;
    var element = document.querySelector(".".concat(rcId));
    while (element && !((_element = element) !== null && _element !== void 0 && (_element = _element.parentElement) !== null && _element !== void 0 && _element.classList.contains('moly-modal'))) {
      var _element, _element2;
      element = (_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.parentElement;
    }
    setPopUpContainer(((_element3 = element) === null || _element3 === void 0 ? void 0 : _element3.parentElement) || document.body);
  }, []);
  useEffect(function () {
    setSelectValue(value);
    if (value === undefined && defaultValue) {
      setSelectValue(defaultValue);
    }
    if ((selectValue === null || selectValue === void 0 ? void 0 : selectValue.toString()) !== (value === null || value === void 0 ? void 0 : value.toString()) && value !== undefined) {
      setSelectValue(value);
    }
    return function () {};
  }, [value]);
  var removeTags = function removeTags(val) {
    var values = selectValue.filter(function (v) {
      return v !== val;
    });
    setSelectValue(_toConsumableArray(values));
    _onChange === null || _onChange === void 0 || _onChange(_toConsumableArray(values));
  };
  var defaultRenderValue = function defaultRenderValue() {
    var _computedSelectValueC = computedSelectValueContainer(),
      width = _computedSelectValueC.width;
    if (mode === 'combobox') {
      var _options$find;
      if (!selectValue && selectValue !== 0) {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }
      return /*#__PURE__*/_jsx("div", {
        className: cn('truncate inline-block flex-1', {
          'text-base-bds-gray-t3': !selectValue && selectValue !== 0,
          'text-base-bds-gray-t4-dis': _props.disabled
        }),
        children: ((_options$find = options.find(function (item) {
          return item.value === selectValue;
        })) === null || _options$find === void 0 ? void 0 : _options$find.label) || selectValue
      });
    }
    if (Array.isArray(selectValue) && selectValue.length > 0) {
      var values = [];
      var labels = selectValue.map(function (val) {
        var _info = options.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.value) === val;
        });
        var _ref = _info || {},
          label = _ref.label,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? '' : _ref$value;
        if (label === undefined && value === '') {
          values.push(val);
          return val;
        } else {
          values.push(value);
        }
        return label;
      });
      if (mode === 'tags') {
        var tag_size = tagSize;
        if (!tagSize) {
          if (size === 'medium') {
            tag_size = 'large';
          }
        }
        return /*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: /*#__PURE__*/_jsx("div", {
            className: cn('flex flex-wrap', {
              'gap-[6px]': !tagSize || tagSize === 'normal',
              'gap-[4px]': tagSize === 'small' || size === 'small'
            }),
            children: labels.map(function (v, idx) {
              return /*#__PURE__*/_jsx(Tag, {
                variant: "light",
                closeIcon: true,
                className: 'w-auto ',
                size: tag_size,
                onClose: function onClose(e) {
                  e === null || e === void 0 || e.preventDefault();
                  e === null || e === void 0 || e.stopPropagation();
                  removeTags(values[idx]);
                },
                children: /*#__PURE__*/_jsx("span", {
                  className: "text-base-bds-gray-t1-title",
                  children: v
                })
              }, v + '_' + idx);
            })
          })
        });
      }
      return /*#__PURE__*/_jsxs("div", {
        style: {
          width: width
        },
        children: ["+ ", labels.length]
      });
    }
  };
  var filterResult = options.filter(function (item) {
    var _item$label, _item$label$toLowerCa, _item$label$toLowerCa2, _item$label$toLowerCa3, _filterValue$toLowerC, _item$value;
    if (!filterValue) return true;
    return (item === null || item === void 0 || (_item$label = item.label) === null || _item$label === void 0 || (_item$label$toLowerCa = _item$label.toLowerCase) === null || _item$label$toLowerCa === void 0 || (_item$label$toLowerCa2 = (_item$label$toLowerCa3 = _item$label$toLowerCa.call(_item$label)).indexOf) === null || _item$label$toLowerCa2 === void 0 ? void 0 : _item$label$toLowerCa2.call(_item$label$toLowerCa3, filterValue === null || filterValue === void 0 || (_filterValue$toLowerC = filterValue.toLowerCase) === null || _filterValue$toLowerC === void 0 ? void 0 : _filterValue$toLowerC.call(filterValue))) > -1 || (item === null || item === void 0 || (_item$value = item.value) === null || _item$value === void 0 || (_item$value = _item$value.toString()) === null || _item$value === void 0 ? void 0 : _item$value.toLowerCase().indexOf(filterValue.toLowerCase())) > -1;
  });
  var placeHolderRender = function placeHolderRender(valueRender) {
    if (mode === 'combobox') {
      if (selectValue || value) {
        return null;
      }
      if (selectValue === 0) return;
    } else if (Array.isArray(selectValue) && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.length) > 0) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: cn('truncate inline-block flex-1', {
        'text-base-bds-gray-t3': !selectValue && selectValue !== 0,
        'text-base-bds-gray-t4-dis': _props.disabled
      }),
      children: placeholder
    }, Math.random() + '_');
  };
  var customRenderValue = function customRenderValue() {
    if (selectValue === undefined || Array.isArray(selectValue) && (selectValue === null || selectValue === void 0 ? void 0 : selectValue.length) === 0) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    if (['tags', 'multiple'].includes(mode)) {
      if (Array.isArray(selectValue)) {
        var optionItems = selectValue.map(function (v) {
          return options.find(function (item) {
            return item.value === v;
          });
        });
        return /*#__PURE__*/_jsx("div", {
          className: "flex-1",
          children: valueRender(selectValue, optionItems)
        });
      }
    } else {
      var changeItem = options.find(function (item) {
        return item.value === selectValue;
      });
      return /*#__PURE__*/_jsx("div", {
        className: "flex-1",
        children: valueRender(selectValue, changeItem)
      });
    }
  };
  var dropDownStyleCss = {
    background: 'var(--bds-gray-bg-float)',
    border: '1px solid var(--bds-gray-ele-line)',
    boxShadow: 'var(--bds-shadow-l1)',
    borderRadius: '8px'
  };
  if (dropDownWidth) {
    dropDownStyleCss.width = dropDownWidth;
  }
  if (direction === 'rtl' && !placement) {
    placement = 'bottomRight';
  }
  var connectClassAndOption = function connectClassAndOption(child) {
    return /*#__PURE__*/_jsx(Option, {
      disabled: child.disabled,
      "data-changed": child.value === selectValue,
      value: child.value,
      className: cn('custom-select-option-selector ', optionStyles, 'last:mb-0  w-full cursor-pointer rounded-md font-normal select-none items-center py-[8px]  pr-2 outline-none  h-[40px] text-base px-[12px]', 'text-base-bds-gray-t1-title', 'focus:bg-base-bds-trans-hover', 'whitespace-nowrap overflow-hidden text-ellipsis', 'flex', 'data-[selected=true]:bg-base-bds-trans-hover', 'rc-select-item-option-selected:inline-block', 'rc-select-item-option-active:bg-base-bds-trans-hover', 'aria-[selected=true]:text-brandColor-bds-brand-900-text', 'data-[changed=true]:text-brandColor-bds-brand-900-text', 'data-[selected=true]:font-medium aria-[selected=true]:font-medium data-[changed=true]:font-medium', 'transition ease-in-out duration-150', {
        'min-h-fit': optionTextAutoBreak,
        'hover:bg-base-bds-trans-hover ': !child.disabled,
        'text-[#ADB1B8] cursor-not-allowed': child.disabled,
        'text-center': contentCenter,
        'h-[26px] py-[4px] px-[8px] text-xs': size === 'small' || size === 'xs',
        'gap-2': mode !== 'combobox'
      }, optionClass),
      children: RenderNode ? RenderNode(child) : defaultOptionLabel(child.label, optionTextAutoBreak)
    }, child.value);
  };
  var connectClassAndOptionGroupLabel = function connectClassAndOptionGroupLabel(item, idx) {
    return /*#__PURE__*/_jsx(Option, {
      disabled: true,
      className: cn('custom-select-option-selector ', optionStyles, 'last:mb-0 w-full cursor-pointer rounded-md font-normal select-none items-center py-[8px]  pr-2 outline-none  h-[40px] text-base px-[12px]', 'text-base-bds-gray-t1-title', 'focus:bg-base-bds-trans-hover', 'whitespace-nowrap overflow-hidden text-ellipsis', 'flex', 'data-[selected=true]:bg-base-bds-trans-hover', 'rc-select-item-option-selected:inline-block', 'rc-select-item-option-active:bg-base-bds-trans-hover', 'aria-[selected=true]:text-brandColor-bds-brand-900-text', 'data-[changed=true]:text-brandColor-bds-brand-900-text', 'data-[selected=true]:font-medium aria-[selected=true]:font-medium data-[changed=true]:font-medium', 'transition ease-in-out duration-150', 'text-sm', 'text-base-bds-gray-t2', 'cursor-default', {
        'h-[26px] py-[4px] px-[8px] text-xs': size === 'small' || size === 'xs',
        'gap-2': mode !== 'combobox',
        'text-center': contentCenter
      }, optionClass, item === null || item === void 0 ? void 0 : item.className),
      children: item === null || item === void 0 ? void 0 : item.label
    }, 'rc_option_' + idx + (item === null || item === void 0 ? void 0 : item.label));
  };
  var mapOptionRender = function mapOptionRender() {
    var list = [];
    filterResult.forEach(function (item, idx) {
      if (item !== null && item !== void 0 && item.options) {
        var _item$options;
        list.push(connectClassAndOptionGroupLabel(item, idx));
        item === null || item === void 0 || (_item$options = item.options) === null || _item$options === void 0 || _item$options.forEach(function (child, childIdx) {
          list.push(connectClassAndOption(child));
        });
      } else if (item.type === 'divider') {
        list.push( /*#__PURE__*/_jsx(Option, {
          disabled: true,
          className: "h-auto",
          children: /*#__PURE__*/_jsx(Divider, {
            style: {
              marginTop: '0px',
              marginBottom: '4px'
            }
          })
        }, 'rc_option_' + idx + item.value));
      } else {
        list.push(connectClassAndOption(item));
      }
    });
    return list;
  };
  useEffect(function () {
    if (!dropdownVisible) {
      setDropDownHover(false);
    }
  }, [dropdownVisible]);
  var visibleChangeHandler = function visibleChangeHandler(visible) {
    if (!visible && shadowRootDelayTime) {
      window.shadowRootTimeOutHidden = setTimeout(function () {
        if (window.selectDropDownClick) {
          window.selectDropDownClick = false;
          return;
        }
        setDropdownVisible(visible);
        setFilterValue('');
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(visible);
      }, shadowRootDelayTime);
      return;
    }
    setDropdownVisible(visible);
    setFilterValue('');
    onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(visible);
  };
  return /*#__PURE__*/_jsx(RcSelect, _objectSpread(_objectSpread({
    virtual: virtual,
    onDropdownVisibleChange: function onDropdownVisibleChange(visible) {
      if (unEnabledDefaultVisible) {
        return;
      }
      visibleChangeHandler(visible);
    },
    open: dropdownVisible,
    optionFilterProp: "text",
    value: selectValue,
    mode: mode,
    placeholder: placeholder,
    onChange: function onChange(val) {
      var molyValueIntercept = false;
      _onChange === null || _onChange === void 0 || _onChange(val, {
        stopPropagation: function stopPropagation() {
          molyValueIntercept = true;
        }
      });
      if (!molyValueIntercept) {
        setSelectValue(val);
      }
    },
    menuItemSelectedIcon: function menuItemSelectedIcon(_ref2) {
      var isSelected = _ref2.isSelected;
      if (!isSelected) return '';
      return /*#__PURE__*/_jsx(CheckIcon, {});
    },
    notFoundContent: /*#__PURE__*/_jsx("div", {
      className: "font-IBM text-center pb-[12px]",
      children: /*#__PURE__*/_jsx(Empty, {
        size: "small",
        title: '',
        status: "noSearchResult",
        subTitle: notFoundText ? notFoundText : ''
      })
    }),
    getRawInputElement: function getRawInputElement() {
      var rawInputElement = customButton ? customButton : /*#__PURE__*/_jsx("div", {
        style: _objectSpread({
          width: width,
          height: mode === 'tags' ? 'auto' : height,
          minWidth: width,
          maxWidth: width
        }, style),
        tabIndex: tabIndex,
        className: cn(rcId, 'font-IBM', 'transition duration-150 ease-in-out', 'focus-visible:shadow-select-shadow focus-visible:outline-none', 'bg-base-bds-gray-ele-line', 'text-base-bds-gray-t1-title', 'border-none box-border ', 'hover:bg-base-bds-gray-ele-border', 'py-[12px]', fontSizeVariable[size], containerVariable[size], {
          // 'shadow-select-shadow': dropdownVisible,
          'py-[11px]': mode === 'tags',
          'py-[7px]': mode === 'tags' && size === 'xs',
          // 'py-[11px]': size === 'small',
          'h-auto': mode === 'tags',
          'bg-base-bds-gray-ele-edge': _props.disabled
        }, className),
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("label", {
              htmlFor: labelId
            }), /*#__PURE__*/_jsx("div", {
              className: cn('font-IBM relative cursor-pointer ', {
                group: selectValue && allowClear,
                'flex relative ': mode === 'tags'
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: cn('flex items-center w-full gap-[8px]', {
                  'h-auto sticky': mode === 'tags'
                }),
                children: [placeHolderRender(), valueRender && customRenderValue(), !valueRender && defaultRenderValue(), allowClear && /*#__PURE__*/_jsx(EmptyIcon, {
                  onClick: function onClick(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (mode === 'combobox') {
                      setSelectValue('');
                      _onChange === null || _onChange === void 0 || _onChange('');
                    } else {
                      setSelectValue([]);
                      _onChange === null || _onChange === void 0 || _onChange([]);
                    }
                  },
                  className: cn('cursor-pointer group-hover:duration-150 group-hover:ease-out group-hover:transition-all w-[20px] h-[20px] ', 'text-[#81858C] absolute opacity-0 group-hover:static group-hover:inline-block group-hover:opacity-100', {
                    'w-[16px] h-[16px]': ['xs', 'small'].includes(size)
                  })
                }), /*#__PURE__*/_jsx(ArrowdownIcon, {
                  className: cn('text-[#81858C] cursor-pointer transition-all group-hover:hidden w-[20px] h-[20px] ', {
                    'text-base-bds-gray-t4-dis': _props.disabled,
                    'rotate-180': dropdownVisible && arrowRotate,
                    'w-[16px] h-[16px]': ['xs', 'small'].includes(size)
                  })
                })]
              })
            })]
          })
        })
      });
      if (hoverAction) {
        return /*#__PURE__*/_jsx("div", {
          onMouseEnter: mouseEnterHandler,
          onMouseLeave: mouseLeaveHandler,
          children: rawInputElement
        });
      }
      return rawInputElement;
    },
    placement: placement
    // direction={'rtl'}
    ,
    animation: "slide-up",
    dropdownStyle: dropDownStyleCss,
    dropdownClassName: cn(dropDownStyles, 'font-IBM  absolute z-[10000] pointer-events-auto text-base-bds-gray-t1-title border-none', 'bg-base-bds-gray-bg-card border-base-bds-gray-ele-line', 'shadow-boxShadow-bds-shadow-l1 p-[4px]', dropdownClassName)
    /**
     *  dropDownWidth,
        dropDownDirection,
     */,
    allowClear: true,
    dropdownRender: function dropdownRender(menu) {
      var searchSize = 'small';
      if (size === 'medium') {
        searchSize = 'small';
      } else if (size === 'small' || size === 'xs') {
        searchSize = 'xs';
      }
      useEffect(function () {
        var isSelect = filterResult.find(function (item) {
          return item.value === selectValue;
        });
        if (!isSelect && dropRef !== null && dropRef !== void 0 && dropRef.current) {
          var el = dropRef === null || dropRef === void 0 ? void 0 : dropRef.current.querySelector('.rc-virtual-list-holder');
          if (el) {
            el.scrollTop = 0;
          }
        }
        return function () {};
      }, [dropRef === null || dropRef === void 0 ? void 0 : dropRef.current, selectValue, filterResult]);
      return /*#__PURE__*/_jsx("div", {
        ref: dropRef,
        onMouseEnter: dropdownMouseEnterHandler,
        onMouseLeave: dropdownMouseLeaveHandler,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [showSearch && /*#__PURE__*/_jsx("div", {
            onMouseDown: function onMouseDown(evt) {
              evt.stopPropagation();
              if (shadowRootDelayTime) {
                window.selectDropDownClick = true;
                clearTimeout(window.shadowRootTimeOutHidden);
              }
            },
            children: /*#__PURE__*/_jsx(Search, {
              size: searchSize,
              id: labelId,
              value: filterValue,
              onChange: function onChange(e) {
                setFilterValue(e.target.value);
              },
              className: cn('w-auto mb-[10px] ', {
                'mx-[2px] h-[40px]': size === 'small'
              })
            })
          }), dropDownHeader === null || dropDownHeader === void 0 ? void 0 : dropDownHeader(), menu, dropDownFooter === null || dropDownFooter === void 0 ? void 0 : dropDownFooter()]
        })
      });
    },
    getPopupContainer: function getPopupContainer() {
      if (_getPopupContainer) {
        return _getPopupContainer === null || _getPopupContainer === void 0 ? void 0 : _getPopupContainer();
      }
      return popUpContainer;
    }
  }, rest), {}, {
    children: mapOptionRender()
  }));
};
Select.displayName = 'Select';
export { Select };